// extracted by mini-css-extract-plugin
module.exports = {"list":"SearchResults-module__list--35RZh","result":"SearchResults-module__result--ZpZYJ"};